/**
 * Sprint 12+C (03.07.2026) — Pionier-Banner
 *
 * Wird oben auf dem Cockpit angezeigt, ausschließlich für User mit
 * `is_pionier === true` oder Tag `pionier_flex4success`.
 *
 * Styling: dezent goldener Akzent, klar vom weißen Cockpit-Hintergrund
 * abgehoben, mobile-responsive.
 *
 * Naming v6: „Flexpfad", „Fokustyp", „Pionier", „Flex4Success".
 */
import React from "react";
import { Sparkles } from "lucide-react";
import { isPionier } from "@/lib/licensing";

export default function PionierBanner({ user }) {
  if (!isPionier(user)) return null;

  return (
    <div
      className="mb-6 rounded-2xl border border-amber-200 bg-gradient-to-r from-amber-50 via-amber-50/60 to-white px-5 py-4 sm:px-6 sm:py-5 shadow-sm"
      data-testid="pionier-banner"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start gap-3 sm:items-center">
        <div
          className="flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-amber-100 flex items-center justify-center"
          aria-hidden="true"
        >
          <Sparkles className="w-5 h-5 text-amber-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p
            className="text-sm sm:text-base font-bold text-amber-900"
            data-testid="pionier-banner-headline"
          >
            Du bist Pionier. Willkommen an Bord.
          </p>
          <p
            className="mt-0.5 text-xs sm:text-sm text-amber-800/80"
            data-testid="pionier-banner-subtext"
          >
            Als Pionier hast du einen exklusiven Bonus: den Kurs „Ruhe im Chaos".
            Danke, dass du von Anfang an dabei bist.
          </p>
        </div>
      </div>
    </div>
  );
}
